import { useEffect } from 'react';
import { warmupHomeImagesOnScroll } from './homeScrollWarmup';

/** After the user scrolls past ~40% of the viewport, prefetch deeper section images. */
export function useHomeScrollImageWarmup(): void {
  useEffect(() => {
    let done = false;

    const maybeWarm = () => {
      if (done) return;
      if (window.scrollY < window.innerHeight * 0.4) return;
      done = true;
      warmupHomeImagesOnScroll();
      window.removeEventListener('scroll', maybeWarm);
    };

    window.addEventListener('scroll', maybeWarm, { passive: true });
    maybeWarm();

    return () => window.removeEventListener('scroll', maybeWarm);
  }, []);
}
